export default {
      id: "icon-bookmark-usage",
      viewBox: "-58 0 404 404.54235",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-bookmark",
      toString: function () {
        return this.url;
      }
    }